import { helper } from '@ember/component/helper';

import { classNames } from '../utils/style-utils';

export default helper(function classNamesHelper(params: (string | boolean | undefined)[]) {
  return classNames(params);
});
